var REMOTE_RESOURCE_PATTERN = /^(\w+:\/\/|\/\/)/;

function isRemoteResource(uri) {
  return REMOTE_RESOURCE_PATTERN.test(uri);
}

module.exports = isRemoteResource;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/utils/is-remote-resource.js
// module id = 355
// module chunks = 0